/* ==========================================================================
   Ravea custom cart controller (Horizon)
   - Auto-adds & toggles $4.45 Shipping Protection
   - Free-gift ladder ($50 eBook, $89 gift card) auto add/remove
   - Free-gift progress bar
   - 7-minute cart reservation timer
   - Real payment-method icons cloned from #rvcart-pay template
   Everything is feature-detected and wrapped so a failure here can never
   break the native Horizon cart.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = {
    PROTECT: 45876222427189,
    GIFTS: [
      { id: 45876222459957, threshold: 5000, name: 'Free eBook Guide + Tracker', value: '$39' },
      { id: 45876222492725, threshold: 8900, name: 'Free $20 Gift Card', value: '$20' }
    ],
    PROTECT_PRICE_LABEL: '$4.45',
    TIMER_SECONDS: 7 * 60,
    LS_PROTECT: 'rvcart_protect',
    LS_TIMER: 'rvcart_timer_start',
    /* subscription upsell ladder: current variant -> the next bundle up */
    LADDER: [
      {
        from: 45875942621237,                 /* 1 Bottle  $39.99 */
        to: 45875942752309,                   /* 2 Bottles $63.99 */
        title: 'Buy Two, Get One Free',
        sub: '3 bottles &middot; 88-day plan',
        price: 6399, was: 11999
      },
      {
        from: 45875942752309,                 /* 2 Bottles $63.99 */
        to: 45875942785077,                   /* 3 Bottles $95.99 */
        title: 'Buy Three, Get Two Free',
        sub: '5 bottles &middot; 148-day plan',
        price: 9599, was: 17999
      }
    ],
    /* rotating social proof in the drawer */
    TESTIMONIALS: [
      { q: 'By week three my morning stiffness eased up and I was sleeping through the night.', a: 'Barbara M.' },
      { q: 'Tried tart cherry before and felt nothing. This is different — and I like that they show the testing.', a: 'Daniel R.' },
      { q: 'Easy on my stomach and my knees feel better on the stairs.', a: 'Susan P.' }
    ]
  };
  CFG.ADDON_IDS = [CFG.PROTECT].concat(CFG.GIFTS.map(function (g) { return g.id; }));

  function ls(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { window.localStorage.removeItem(k); } catch (e) {} }
  function money(c) { return '$' + ((Number(c) || 0) / 100).toFixed(2); }
  function protectionOn() { return ls(CFG.LS_PROTECT) !== '0'; }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  var SVG = {
    clock: '<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><path d="M12 7v5l3.5 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none"><path d="M20 12v8H4v-8" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M2 8h20v4H2z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M12 8v12" stroke="currentColor" stroke-width="2"/><path d="M12 8S10.5 4 8 4a2 2 0 000 4h4zm0 0s1.5-4 4-4a2 2 0 010 4h-4z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    up: '<svg viewBox="0 0 24 24" fill="none"><path d="M12 19V5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M6 11l6-6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  /* ---- Shopify AJAX cart ---- */
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function addItem(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); });
  }
  function changeItem(id, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function findItem(cart, vid) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (Number(items[i].variant_id) === Number(vid)) return items[i];
    }
    return null;
  }
  /* subtotal EXCLUDING addons — keeps the target stable so reconcile can't loop */
  function eligibleSubtotal(cart) {
    var items = (cart && cart.items) || [], sum = 0;
    for (var i = 0; i < items.length; i++) {
      if (CFG.ADDON_IDS.indexOf(Number(items[i].variant_id)) === -1) sum += Number(items[i].final_line_price) || 0;
    }
    return sum;
  }
  function hasRealProduct(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (CFG.ADDON_IDS.indexOf(Number(items[i].variant_id)) === -1 && items[i].quantity > 0) return true;
    }
    return false;
  }

  /* ---- reconcile, loop-guarded ---- */
  var busy = false, pending = false, selfMutating = false;

  function desiredActions(cart) {
    var actions = [], real = hasRealProduct(cart);

    var inCartProtect = findItem(cart, CFG.PROTECT);
    if (protectionOn() && real && !inCartProtect) actions.push({ t: 'add', id: CFG.PROTECT });
    else if ((!protectionOn() || !real) && inCartProtect) actions.push({ t: 'rm', id: CFG.PROTECT });

    var sub = eligibleSubtotal(cart);
    for (var i = 0; i < CFG.GIFTS.length; i++) {
      var g = CFG.GIFTS[i], has = findItem(cart, g.id), ok = real && sub >= g.threshold;
      if (ok && !has) actions.push({ t: 'add', id: g.id });
      else if (!ok && has) actions.push({ t: 'rm', id: g.id });
    }
    return actions;
  }

  function runActions(actions) {
    var p = Promise.resolve();
    actions.forEach(function (a) {
      p = p.then(function () {
        return a.t === 'add' ? addItem(a.id, 1) : changeItem(a.id, 0);
      }).catch(function () {});
    });
    return p;
  }

  function cartSectionWrappers() {
    var out = [];
    document.querySelectorAll('cart-items-component, cart-drawer-component').forEach(function (c) {
      var w = c.closest('[id^="shopify-section-"]');
      if (w && out.indexOf(w) === -1) out.push(w);
    });
    return out;
  }

  function refreshSections() {
    try {
      var wrappers = cartSectionWrappers();
      if (!wrappers.length) return Promise.resolve();
      var ids = wrappers.map(function (w) { return w.id.replace('shopify-section-', ''); });
      return fetch(location.pathname + '?sections=' + encodeURIComponent(ids.join(',')), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          selfMutating = true;
          wrappers.forEach(function (w) {
            var sid = w.id.replace('shopify-section-', '');
            if (data && typeof data[sid] === 'string') { try { w.innerHTML = data[sid]; } catch (e) {} }
          });
          setTimeout(function () { selfMutating = false; }, 0);
        }).catch(function () { selfMutating = false; });
    } catch (e) { return Promise.resolve(); }
  }

  function sync() {
    if (busy) { pending = true; return; }
    busy = true;
    getCart().then(function (cart) {
      var actions = desiredActions(cart);
      if (actions.length) return runActions(actions).then(refreshSections).then(getCart);
      return cart;
    }).then(function (cart) {
      try { render(cart); } catch (e) {}
      busy = false;
      if (pending) { pending = false; sync(); }
    }).catch(function () {
      busy = false;
      if (pending) { pending = false; sync(); }
    });
  }

  /* ---- reservation timer ---- */
  function ensureTimerStart(cart) {
    if (cart && cart.item_count > 0) {
      /* start fresh if never started, or if a previous visit's timer already ran out —
         otherwise a returning shopper sees a permanently dead 0:00 */
      var start = Number(ls(CFG.LS_TIMER));
      var expired = !start || (Date.now() - start) / 1000 >= CFG.TIMER_SECONDS;
      if (expired) lsSet(CFG.LS_TIMER, String(Date.now()));
    }
    else lsDel(CFG.LS_TIMER);
  }
  function timerText() {
    var start = Number(ls(CFG.LS_TIMER));
    if (!start) return { text: '7:00', expired: false };
    var left = CFG.TIMER_SECONDS - Math.floor((Date.now() - start) / 1000);
    if (left <= 0) return { text: '0:00', expired: true };
    var m = Math.floor(left / 60), s = left % 60;
    return { text: m + ':' + (s < 10 ? '0' : '') + s, expired: false };
  }
  function tickTimer() {
    try {
      var el = document.querySelector('.rvcart-timer__value');
      if (!el) return;
      var t = timerText();
      el.textContent = t.text;
      var pill = el.closest('.rvcart-timer');
      if (pill) pill.classList.toggle('rvcart-timer--expired', t.expired);
    } catch (e) {}
  }
  function startTimerInterval() {
    if (window.__rvTimerInt) return;
    window.__rvTimerInt = setInterval(tickTimer, 1000);
  }

  /* ---- UI ---- */
  function buildUI(cart) {
    var sub = eligibleSubtotal(cart);
    var maxT = CFG.GIFTS[CFG.GIFTS.length - 1].threshold;

    var next = null;
    for (var i = 0; i < CFG.GIFTS.length; i++) {
      if (sub < CFG.GIFTS[i].threshold) { next = CFG.GIFTS[i]; break; }
    }
    var pct = Math.max(0, Math.min(100, (sub / maxT) * 100));

    var msg = next
      ? SVG.gift + '<span>You are ' + money(next.threshold - sub) + ' away from a ' + esc(next.name) + '!</span>'
      : SVG.gift + '<span>You have unlocked all your free gifts!</span>';

    var marks = CFG.GIFTS.map(function (g) {
      var pos = Math.max(0, Math.min(100, (g.threshold / maxT) * 100));
      return '<span class="rvcart-bar__mark' + (sub >= g.threshold ? ' rvcart-bar__mark--hit' : '') + '" style="left:' + pos + '%"></span>';
    }).join('');

    var gifts = CFG.GIFTS.map(function (g) {
      var on = sub >= g.threshold;
      return '<li class="rvcart-gifts__item' + (on ? '' : ' rvcart-gifts__item--locked') + '">' +
        (on ? SVG.check : SVG.gift) +
        '<span class="rvcart-gifts__name">' + esc(g.name) + '</span>' +
        '<span class="rvcart-gifts__price"><s>' + esc(g.value) + '</s><span class="rvcart-gifts__free">FREE</span></span></li>';
    }).join('');

    var t = timerText();

    /* ---- subscription upsell ---- */
    var up = findUpsell(cart), upHtml = '';
    if (up) {
      upHtml =
        '<div class="rvcart-up">' +
          '<div class="rvcart-up__tag">' + SVG.up + '<span>Upgrade &amp; save ' + money(up.extraSave) + ' more</span></div>' +
          '<div class="rvcart-up__row">' +
            (up.img ? '<span class="rvcart-up__im"><img src="' + up.img + '" alt=""></span>' : '') +
            '<span class="rvcart-up__txt">' +
              '<span class="rvcart-up__t">' + up.title + '</span>' +
              '<span class="rvcart-up__s">' + up.sub + '</span>' +
            '</span>' +
            '<span class="rvcart-up__p"><s>' + money(up.was) + '</s><b>' + money(up.price) + '</b></span>' +
          '</div>' +
          '<button type="button" class="rvcart-up__btn" data-to="' + up.to + '" data-from="' + up.from +
            '"' + (up.plan ? ' data-plan="' + up.plan + '"' : '') + '>Upgrade my order</button>' +
        '</div>';
    }

    return '' +
      '<div class="rvcart-timer' + (t.expired ? ' rvcart-timer--expired' : '') + '">' +
        SVG.clock + '<span>Your cart is reserved for </span><span class="rvcart-timer__value">' + t.text + '</span>' +
      '</div>' +
      upHtml +
      '<div class="rvcart-progress">' +
        '<div class="rvcart-progress__msg">' + msg + '</div>' +
        '<div class="rvcart-bar"><div class="rvcart-bar__fill" style="width:' + pct + '%"></div>' + marks + '</div>' +
        '<ul class="rvcart-gifts">' + gifts + '</ul>' +
      '</div>' +
      '<div class="rvcart-protect">' +
        '<span class="rvcart-protect__icon">' + SVG.shield + '</span>' +
        '<span class="rvcart-protect__text">' +
          '<span class="rvcart-protect__title">Shipping Protection &mdash; ' + CFG.PROTECT_PRICE_LABEL + '</span>' +
          '<span class="rvcart-protect__sub">Covers lost, damaged or stolen orders.</span>' +
        '</span>' +
        '<button type="button" class="rvcart-switch" role="switch" aria-checked="' + (protectionOn() ? 'true' : 'false') + '" aria-label="Toggle shipping protection"><span class="rvcart-switch__dot"></span></button>' +
      '</div>' +
      buildTestimonials() +
      '<div class="rvcart-pay" aria-label="Accepted payment methods"></div>';
  }

  function buildTestimonials() {
    if (!CFG.TESTIMONIALS || !CFG.TESTIMONIALS.length) return '';
    var slides = CFG.TESTIMONIALS.map(function (t, i) {
      return '<li class="rvcart-tm__s' + (i === 0 ? ' is-on' : '') + '">' +
        '<span class="rvcart-tm__q">&ldquo;' + esc(t.q) + '&rdquo;</span>' +
        '<span class="rvcart-tm__a">' + esc(t.a) + ' &middot; <b>Verified</b></span>' +
      '</li>';
    }).join('');
    return '<div class="rvcart-tm">' +
      '<div class="rvcart-tm__st">&#9733;&#9733;&#9733;&#9733;&#9733;</div>' +
      '<ul class="rvcart-tm__list">' + slides + '</ul>' +
    '</div>';
  }

  /* one interval for the whole page, guarded like the timer */
  function startTestimonialRotation() {
    if (window.__rvTmInt) return;
    window.__rvTmInt = setInterval(function () {
      try {
        document.querySelectorAll('.rvcart-tm__list').forEach(function (list) {
          var items = list.children;
          if (items.length < 2) return;
          var cur = 0;
          for (var i = 0; i < items.length; i++) {
            if (items[i].classList.contains('is-on')) { cur = i; break; }
          }
          items[cur].classList.remove('is-on');
          items[(cur + 1) % items.length].classList.add('is-on');
        });
      } catch (e) {}
    }, 4500);
  }

  function fillPayIcons(box) {
    try {
      var tpl = document.getElementById('rvcart-pay');
      var slot = box.querySelector('.rvcart-pay');
      if (!tpl || !slot || slot.childNodes.length) return;
      if (tpl.content) slot.appendChild(tpl.content.cloneNode(true));
    } catch (e) {}
  }

  /* Find the highest-value upgrade available for what's in the cart.
     Preserves the customer's selling plan so a subscriber stays a subscriber. */
  function findUpsell(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < CFG.LADDER.length; i++) {
      var step = CFG.LADDER[i];
      for (var j = 0; j < items.length; j++) {
        var it = items[j];
        if (Number(it.variant_id) !== Number(step.from)) continue;
        /* already has the upgrade in cart? nothing to sell */
        if (findItem(cart, step.to)) continue;
        var plan = null;
        try { plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan.id; } catch (e) {}
        return {
          from: step.from, to: step.to, title: step.title, sub: step.sub,
          price: step.price, was: step.was,
          extraSave: Math.max(0, (step.was - step.price) - (Number(it.original_line_price) - Number(it.final_line_price))),
          img: it.featured_image && it.featured_image.url ? it.featured_image.url : null,
          plan: plan
        };
      }
    }
    return null;
  }

  function doUpgrade(toId, fromId, planId) {
    if (busy) return;
    busy = true;
    var body = { items: [{ id: Number(toId), quantity: 1 }] };
    if (planId) body.items[0].selling_plan = Number(planId);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function () { return changeItem(fromId, 0); })
      .then(refreshSections)
      .then(function () { busy = false; sync(); })
      .catch(function () { busy = false; sync(); });
  }

  function wire(box) {
    var sw = box.querySelector('.rvcart-switch');
    if (sw && !sw.__rvWired) {
      sw.__rvWired = true;
      sw.addEventListener('click', function () {
        var nowOn = sw.getAttribute('aria-checked') !== 'true';
        sw.setAttribute('aria-checked', nowOn ? 'true' : 'false');
        lsSet(CFG.LS_PROTECT, nowOn ? '1' : '0');
        sync();
      });
    }
    var ub = box.querySelector('.rvcart-up__btn');
    if (ub && !ub.__rvWired) {
      ub.__rvWired = true;
      ub.addEventListener('click', function () {
        ub.disabled = true;
        ub.textContent = 'Upgrading…';
        doUpgrade(ub.getAttribute('data-to'), ub.getAttribute('data-from'), ub.getAttribute('data-plan'));
      });
    }
  }

  function render(cart) {
    ensureTimerStart(cart);
    var html = buildUI(cart);
    var targets = Array.prototype.slice.call(document.querySelectorAll('.cart__ctas'));
    selfMutating = true;
    targets.forEach(function (cta) {
      var prev = cta.previousElementSibling, box;
      if (prev && prev.classList && prev.classList.contains('rvcart-ui')) box = prev;
      else {
        box = document.createElement('div');
        box.className = 'rvcart-ui';
        cta.parentNode.insertBefore(box, cta);
      }
      box.innerHTML = html;
      fillPayIcons(box);
      wire(box);
    });
    var first = document.querySelector('.rvcart-ui');
    if (first && !first.id) first.id = 'rvcart-ui';
    setTimeout(function () { selfMutating = false; }, 0);
    startTimerInterval();
    startTestimonialRotation();
  }

  /* ---- observe Horizon re-renders ---- */
  var schedT = null;
  function scheduleSync() {
    if (schedT) clearTimeout(schedT);
    schedT = setTimeout(function () { schedT = null; sync(); }, 250);
  }

  function observe() {
    try {
      new MutationObserver(function (muts) {
        if (selfMutating) return;
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t && t.closest && t.closest('.rvcart-ui')) continue;
          scheduleSync();
          return;
        }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  function boot() {
    try {
      observe();
      sync();
      document.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('.cart-icon, [ref="cartIcon"], a[href$="/cart"], cart-drawer-component')) scheduleSync();
      }, true);
      window.addEventListener('pageshow', scheduleSync);
    } catch (e) {}
  }

  /* Public hook so the buy box can attach shipping protection + free gifts
     before sending the customer straight to checkout. */
  window.RaveaCart = {
    reconcile: function () {
      return getCart()
        .then(function (cart) {
          var actions = desiredActions(cart);
          return actions.length ? runActions(actions) : null;
        })
        .catch(function () { /* never block checkout on an addon failure */ });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
